import { render, staticRenderFns } from "./PurchaseRequestFilters.vue?vue&type=template&id=e8cb2ffc&"
import script from "./PurchaseRequestFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestFilters.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestFilters.vue?vue&type=style&index=0&id=e8cb2ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports